import styled from 'styled-components'

import { Button, Header } from '../../components/ui'

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
`
export const SigninForm = styled.form`
	width: 570px;
	height: 311px;
	background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
	border-radius: 20px;
	padding: 50px 110px;
	text-align: center;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.5);
`
export const FormHeader = styled(Header)`
	margin-bottom: 30px;
`
export const FieldsWrapper = styled.div`
	& > * {
		margin-bottom: 30px;
	}
`
export const Btn = styled(Button)`
	width: 100%;
`
